/*
 * Filter does exact value matching and
 * most of the time we get those values from querystring,
 * hence we expect string value matches and
 * want to prevent mismatch due to type mixing.
 */
function getFilterOptions(options) {
  return options.map(filterOptionMapper);
}

function filterOptionMapper({ label, value }) {
  return {
    label,
    value: String(value),
  };
}

export { getFilterOptions, filterOptionMapper };
